function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Itinerary = function Itinerary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M4.727 7.598a3.5 3.5 0 1 1 3.335-4.566h5.126C13.617 1.57 14.96.5 16.545.5c1.773 0 3.243 1.338 3.47 3.065a4.96 4.96 0 0 1 2.737 4.441 4.98 4.98 0 0 1-4.976 4.976l-2.519.001a3.535 3.535 0 0 1-3.38 2.484 3.535 3.535 0 0 1-3.381-2.484h-2.52A2.98 2.98 0 0 0 3 15.956c0 .894.41 1.73 1.075 2.287a3.5 3.5 0 0 1 3.152-1.981 3.506 3.506 0 0 1 3.4 2.668h8.51l-.779-.78a1 1 0 0 1 .001-1.413 1 1 0 0 1 1.414 0l2.483 2.486q.044.043.08.09l-.079-.09a1 1 0 0 1 .292.688v.04q0 .034-.004.07l.004-.09a1 1 0 0 1-.21.613l-.006.008-.003.004-.064.072-.01.01-2.483 2.487a1 1 0 0 1-1.414 0 1 1 0 0 1-.001-1.414l.778-.781-8.61.001a3.51 3.51 0 0 1-3.3 2.33 3.506 3.506 0 0 1-3.436-2.834A5.01 5.01 0 0 1 1 15.958a4.98 4.98 0 0 1 4.963-4.976h2.524a3.535 3.535 0 0 1 3.39-2.515 3.535 3.535 0 0 1 3.39 2.515h2.509a2.98 2.98 0 0 0 2.976-2.976c0-.92-.42-1.767-1.115-2.322a3.5 3.5 0 0 1-3.092 1.88c-1.585 0-2.928-1.07-3.357-2.53l-5.087-.001a3.5 3.5 0 0 1-3.374 2.565m2.5 10.665c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5m4.65-7.796c-.846 0-1.533.673-1.533 1.5s.687 1.5 1.532 1.5c.846 0 1.533-.673 1.533-1.5s-.687-1.5-1.533-1.5M16.544 2.5c-.827 0-1.5.687-1.5 1.532s.673 1.532 1.5 1.532 1.5-.687 1.5-1.532-.673-1.532-1.5-1.532"
  }));
};
export default Itinerary;